import store from '@/store'

export default (to, from, next) => {
  switch (true) {
    case Boolean(store.getters['auth/isAuthenticated']()):
      next()
      break

    default:
      next({ path: '/login', query: to.query })
      break
  }
}
